module.exports = __webpack_public_path__ + "img/logoESP-color.b245eb36.png";